import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class EnvironmentService {
  

  public getPubAdminBaseAddress(): string {
    var environment = (window as any).__env;
    return environment.pubAdminBaseAddress;
  }

  public getManufacturingProfileEditorBaseAddress(): string {
    var environment = (window as any).__env;
    return environment?.manufacturingProfileEditorBaseAddress;
  }

  public getTrackerBaseAddress(): string {
    var environment = (window as any).__env;
    return environment?.trackerBaseAddress;
  }

  public getContentSchedulerBaseAddress(): string {
    var environment = (window as any).__env;
    return environment?.contentSchedulerBaseAddress;
  }

  public getEnvironmentName(): string {
    var environment = (window as any).__env;
    return environment?.environmentName;
  }
}
